import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Loader2 } from "lucide-react";
import { useBrand } from "../../lib/BrandContext";
import api, { formatApiErrorDetail } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function ForgotPassword() {
  const brand = useBrand();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setMessage(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setMessage("If that email exists, we've sent a password reset link. Please check your inbox and spam folder.");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen bg-ink-100/40">
      <div className="m-auto w-full max-w-md px-6 py-10">
        <Link to="/" className="flex items-center gap-2 font-heading text-xl font-bold text-ink-900">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-brand text-white"><ShieldCheck className="h-5 w-5" /></span>
          {brand.app_name}
        </Link>
        <div className="mt-8 rounded-2xl border border-ink-100 bg-white p-8 shadow-sm">
          <h1 className="font-heading text-2xl font-bold text-ink-900">Reset your password</h1>
          <p className="mt-1 text-sm text-ink-500">Enter your email and we’ll send a reset link.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="forgot-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 h-12" data-testid="forgot-email-input" />
            </div>
            {message ? <p className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-700">{message}</p> : null}
            {error ? <p className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</p> : null}
            <Button type="submit" disabled={loading} className="h-12 w-full bg-brand font-semibold text-white hover:bg-brand-hover" data-testid="forgot-submit-button">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
            </Button>
          </form>
          <p className="mt-4 text-sm text-ink-700 text-center">
            <Link to="/login" className="font-semibold text-brand hover:underline">Back to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
